import { c as _c } from "react/compiler-runtime";
import WorldTour from "./world-tour";
export function WorldTourLayout() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="mx-auto pt-8 lg:px-4"><h2 className="theme-transition container flex items-center text-2xl text-current"><a className="appearance-auto" id="world-tour">World Tour - Total Visitors</a></h2><p className="text-muted-foreground container mb-2 text-sm">Work in Progress</p><WorldTour /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}